import { ChangeEvent, FC, ReactElement } from 'react'

import { MaterialIcon } from '@/components/MaterialIcon/MaterialIcon'

import './FormSelect.scss'


interface FormSelectProps {
    options: ReactElement[]
    selected: string | null
    title?: string
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void
}

export const FormSelect: FC<FormSelectProps> = ({
    options,
    selected,
    title,
    onChange,
}) => (
    <div className="form-select">
        { title && (
            <div className="form-select__title">
                {title}
            </div>
        )}
        <div className="form-select__select-container">
            <select
                value={selected || ''}
                className="form-select__select"
                onChange={onChange}
            >
                {options}
            </select>
            <MaterialIcon kind="keyboard_arrow_down" className="form-select__arrow-down" fontSize={24} />
        </div>
    </div>
)
